// Empty stand-in for Node's `crypto` in browser bundles (see `turbopack.resolveAlias` in
// next.config.mjs). crypto-js — pulled in by the gt-* translation packages — only falls back to
// `require("crypto")` when `window.crypto` is missing, but Turbopack still bundled Next's
// crypto-browserify polyfill (~1.4 MB raw / ~190 KB gzip) into every page because of it.
export {}
